import React, { useState, useContext, useEffect, useRef } from "react";
import { useParams, Link, useLocation, useNavigate } from "react-router-dom";

import SuiButton from "components/SuiButton";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiBadge from "components/SuiBadge";
import SuiInput from "components/SuiInput";

import Tooltip from "@mui/material/Tooltip";
import PostImageWrapper from "pages/de/posts/components/PostImageWrapper";
import ReactPlayer from "react-player";
import Skeleton from "@mui/material/Skeleton";

import parse from "html-react-parser";
import { Badge } from "antd";

const ColumnGrid = ({ columnGrid, handleClickContentStyle }) => {
  const [uploading, setUploading] = useState(false);
  const columnContent = columnGrid?.content || [{}];

  const renderColumnGridContent = (item) => {
    if (item?.type == "text") {
      return (
        <SuiBox
          sx={{
            mt: 1,
            position: "relative",
          }}
        >
          <SuiTypography variant="body1">{parse(item?.caption)}</SuiTypography>
        </SuiBox>
      );
    } else if (item.type == "video") {
      return item?.video ? (
        <ReactPlayer
          controls={true}
          url={item?.video?.url}
          height="100%"
          style={{ minHeight: 50 }}
          width="100%"
          fallback={<Skeleton animation="wave" height={200} width="100%" variant="rectangular" />}
        />
      ) : null;
    } else {
      return item?.img ? (
        <PostImageWrapper
          item={item}
          sx={{
            height: "auto",
            width: "100%",
            cursor: item?.resource_id && item?.type == "style" ? "pointer" : "default",
          }}
          handleClick={
            item?.resource_id && item?.type == "style" && handleClickContentStyle
              ? () => handleClickContentStyle(item)
              : null
          }
          isEdit={false}
        />
      ) : null;
    }
  };

  return (
    <SuiBox>
      <Backdrop sx={{ color: "#fff", zIndex: (theme) => 99999 }} open={uploading}>
        <CircularProgress color="inherit" />
      </Backdrop>

      <SuiBox>
        <SuiBox sx={{ width: "100%", display: "flex", gap: columnGrid?.gap + "px" }}>
          {columnContent.map((x, index) => (
            <SuiBox sx={{ width: x?.width || (100 * 1.0) / columnContent.length + "%" }}>
              {renderColumnGridContent(x)}
            </SuiBox>
          ))}
        </SuiBox>
      </SuiBox>
    </SuiBox>
  );
};

export default ColumnGrid;
